import log from 'loglevel';
import DBDataParser from '../db/DBDataParser';
/**
 * 数据降级策略控制器
 *
 * @export
 * @class DBCompatController
 */
export default class DBCompatController {
  constructor() {
    this.CLASS_NAME = this.constructor.name;
    this.dbData = [];
    window.dataInstallComplete = false;
  }

  init(option) {}

  install(data) {
    log.info('start parse data.');
    this.dbData = DBDataParser.parse(data);
    log.info('db data parse complete.');
    log.info(`here are ${this.dbData.length} pieces of data.`);
    window.dataInstallComplete = true;
  }

  destroy() {
    window.dataInstallComplete = false;
  }
}
